if (!customElements.get('product-description-toggle')) {
  class ProductDescriptionToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-description-toggle]');
      this.content = this.querySelector('[data-description-content]');

      if (!this.button || !this.content) return;

      this.button.addEventListener('click', () => this.toggle());
      this.setExpanded(false);

      // Hide the button when the whole description already fits in the collapsed lines.
      this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
      this.resizeObserver.observe(this.content);
      this.updateOverflow();

      // Fonts loading or a viewport resize change line wrapping without resizing the content box.
      this.onWindowResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.updateOverflow(), 150);
      };
      window.addEventListener('resize', this.onWindowResize);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected) this.updateOverflow();
        });
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      clearTimeout(this.resizeTimer);
    }

    updateOverflow() {
      if (this.classList.contains('is-expanded')) return;
      this.button.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
    }

    toggle() {
      this.setExpanded(this.button.getAttribute('aria-expanded') !== 'true');
    }

    setExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.button.setAttribute('aria-expanded', String(expanded));
      this.querySelector('[data-collapsed-label]').hidden = expanded;
      this.querySelector('[data-expanded-label]').hidden = !expanded;
    }
  }

  customElements.define('product-description-toggle', ProductDescriptionToggle);
}
